// src/App.js
import "./App.css";
import { Routes, Route } from "react-router-dom";

// Import existing pages
import Landing from "./pages/Landing/Landing";
import Inventory from "./pages/Inventory/Inventory";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Nav from "./pages/Landing/Nav";
import SignedInStudent from "./pages/SignedInStudent/SignedInStudent";
import Register from "./pages/Register/Register";
import AdminLogin from "./pages/AdminLogin/AdminLogin";
import AddProduct from "./pages/AddProduct/AddProduct";
import EditProduct from "./pages/EditProduct/EditProduct";

// Import additional user login page
import UserLogin from "./pages/UserLogin/UserLogin";

// Import custom components
import Splash from "./pages/Splash/Splash";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Nav /> {/* Always show the regular navigation */}

        <Routes>
          {/* 1. SPLASH ROUTE (UNPROTECTED) */}
          <Route path="/" element={<Splash />} />

          {/* 2. LANDING ROUTE (PROTECTED - ADMIN) */}
          <Route
            path="/landing"
            element={
              <ProtectedRoute requiredRole="admin">
                <Landing />
              </ProtectedRoute>
            }
          />

          {/* 3. INVENTORY ROUTE (PROTECTED - ADMIN) */}
          <Route
            path="/inventory"
            element={
              <ProtectedRoute requiredRole="admin">
                <Inventory />
              </ProtectedRoute>
            }
          />

          {/* 4. PRODUCT DETAILS ROUTE (PROTECTED - ADMIN) */}
          <Route
            path="/inventory/:sku"
            element={
              <ProtectedRoute requiredRole="admin">
                <ProductDetails />
              </ProtectedRoute>
            }
          />

          {/* 5. ADD PRODUCT (PROTECTED - ADMIN) */}
          <Route
            path="/add-product"
            element={
              <ProtectedRoute requiredRole="admin">
                <AddProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-product/:sku"
            element={
              <ProtectedRoute requiredRole="admin">
                <EditProduct />
              </ProtectedRoute>
            }
          />

          {/* 6. SIGNED IN STUDENT (PROTECTED - ADMIN) */}
          <Route
            path="/signedInStudent"
            element={
              <ProtectedRoute requiredRole="admin">
                <SignedInStudent />
              </ProtectedRoute>
            }
          />

          {/* 7. REGISTER ROUTE (PROTECTED - ADMIN) */}
          <Route
            path="/register"
            element={
              <ProtectedRoute requiredRole="admin">
                <Register />
              </ProtectedRoute>
            }
          />

          {/* 8. ADMIN LOGIN (UNPROTECTED) */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* 9. USER LOGIN (UNPROTECTED) */}
          <Route path="/user/login" element={<UserLogin />} />

          {/* 10. OPTIONAL: 404 PAGE NOT FOUND */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
